import { IFormCompensation } from 'legacy/lut/classes/models/partner360/IFormCompensation'
import { IFormPartnerBasicInfo } from 'legacy/lut/classes/models/partner360/IFormPartnerBasicInfo'
import { IRowItem } from 'legacy/lut/components/widgets/public/partner360/Compensation'

import { toFormat } from 'core/classes/helpers/DateHelper'

import { IFormActualsAndPlans } from '../../models/partner360/IFormHistoricalResults'
import { ProgramTypes } from '../../models/ProgramTypes'

import { getNotApplicableField } from './getNotApplicableField'

export interface IMIFItem extends IFormActualsAndPlans {
  Achievment: number
  Editable: boolean
  Changed: boolean
}

interface ITargetProportions {
  item1: number
  item2: number
}

export default class CompenstaionHelper {
  /**
   * @deprecated
   * */
  public static formatMoney = (number: number, isInteger: boolean = false) => {
    const options: Intl.NumberFormatOptions = {
      style: 'currency',
      currency: 'USD',
    }
    if (isInteger) {
      options.minimumFractionDigits = 0
      options.maximumFractionDigits = 0
    }
    return (number || 0).toLocaleString('en-US', options).replace(/\$/g, '')
  }

  public static formatMoneyInteger = (number: number) => {
    const currencyString = Math.abs(number || 0)
      .toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })
      .substring(1)
    return (number < 0 ? '-' : '') + currencyString
  }

  public static convertDateToFYDate = (date: Date) => {
    let month = date.getMonth() + 2
    let year = date.getFullYear()
    if (month >= 12) {
      year += 1
    }
    month %= 12
    return new Date(year, month, 1)
  }

  // TODO: use JBPSettings to get FYear by Current date
  public static getFYear = (date: Date) => {
    return CompenstaionHelper.convertDateToFYDate(date).getFullYear()
  }

  public static getQuarterDate = (fYear: number, quarter: number) => {
    const fyMonth = (quarter - 1) * 3
    let month = fyMonth - 2
    let year = fYear
    if (month < 0) {
      year -= 1
    }
    month = (month + 12) % 12
    return toFormat(new Date(year, month, 1, 12), 'YYYY-MM-DDTHH:mm:ss')
  }

  // TODO: use JBPSettings to get FQuarter by Current date
  public static getQuarter = (value: string) => {
    const date = new Date(value)
    let month = date.getMonth() + 1 + 2
    month = month > 12 ? month % 12 : month
    const quarter = Math.ceil(month / 3)
    if (quarter > 4) {
      return '1'
    }
    return quarter.toFixed(0)
  }

  private static calculateTotal = (
    category: string,
    targets: IFormActualsAndPlans[],
    sales: IFormActualsAndPlans[],
    notApplicable: boolean
  ) => {
    const totalItem: IRowItem = {
      TotalNet: 0,
      TotalNetUSD: 0,
      TargetTotal: 0,
      TargetQ1: 0,
      TargetQ2: 0,
      TargetQ3: 0,
      TargetQ4: 0,
      TargetTotalUSD: 0,
      TargetQ1USD: 0,
      TargetQ2USD: 0,
      TargetQ3USD: 0,
      TargetQ4USD: 0,
      PercentInfo: [],
      Category: category,
      SubCategory: 'jbp-overall',
      TotalRebateValue: 0,
      TotalRebateValueUSD: 0,

      TotalNdp: 0,
      TotalNdpUSD: 0,
      TargetTotalNdp: 0,
      TargetQ1Ndp: 0,
      TargetQ2Ndp: 0,
      TargetQ3Ndp: 0,
      TargetQ4Ndp: 0,
      TargetTotalUSDNdp: 0,
      TargetQ1USDNdp: 0,
      TargetQ2USDNdp: 0,
      TargetQ3USDNdp: 0,
      TargetQ4USDNdp: 0,
      TotalRebateValueNdp: 0,
      TotalRebateValueUSDNdp: 0,
    }
    if (notApplicable) {
      return totalItem
    }
    sales
      .filter((el) => el.Category === category)
      .map((el) => {
        totalItem.TotalNet += el.TotalSumLocalCurrency
        totalItem.TotalNetUSD += el.TotalSumUSD

        totalItem.TotalNdp += el.TotalSumLocalCurrencyNdp
        totalItem.TotalNdpUSD += el.TotalSumUSDNdp
      })

    targets
      .filter((el) => el.Category === category)
      .map((el) => {
        totalItem.TargetTotal += el.TotalSumLocalCurrency
        totalItem.TargetTotalNdp += el.TotalSumLocalCurrencyNdp

        totalItem[`TargetQ${el.FQuarter}`] += el.TotalSumLocalCurrency
        totalItem[`TargetQ${el.FQuarter}Ndp`] += el.TotalSumLocalCurrencyNdp

        totalItem.TargetTotalUSD += el.TotalSumUSD
        totalItem.TargetTotalUSDNdp += el.TotalSumUSDNdp

        totalItem[`TargetQ${el.FQuarter}USD`] += el.TotalSumUSD
        totalItem[`TargetQ${el.FQuarter}USDNdp`] += el.TotalSumUSDNdp
      })
    return totalItem
  }

  private static getNotApplicable = (
    category: string,
    printTransactional: boolean,
    partnerInfo?: IFormPartnerBasicInfo
  ) => {
    const notApplicableField = getNotApplicableField(category)
    const ignoreNotApplicable =
      !printTransactional &&
      partnerInfo &&
      partnerInfo.Country === 'Germany' &&
      category.includes('accessories')
    return !ignoreNotApplicable && !!partnerInfo && !!partnerInfo[notApplicableField]
  }

  public static calculateData = (
    comps: IFormCompensation[],
    sourceData: IFormActualsAndPlans[],
    printTransactional?: boolean,
    partnerInfo?: IFormPartnerBasicInfo
  ) => {
    const targets = sourceData.filter((el) => el.IsTarget)
    const sales = sourceData.filter((el) => !el.IsTarget)
    const result: IRowItem[] = []
    let valueItems: IRowItem[] = []
    let category = comps.length ? comps[0].Category : ''
    let notApplicable = CompenstaionHelper.getNotApplicable(
      category,
      !!printTransactional,
      partnerInfo
    )
    comps.map((c) => {
      if (category !== c.Category) {
        if (category) {
          const totalItem = CompenstaionHelper.calculateTotal(
            category,
            targets,
            sales,
            notApplicable
          )
          result.push(totalItem, ...valueItems)
          valueItems = []
        }
        category = c.Category
        notApplicable = CompenstaionHelper.getNotApplicable(
          category,
          !!printTransactional,
          partnerInfo
        )
      }
      const newItem: IRowItem = {
        TotalNet: 0,
        TotalNetUSD: 0,
        TargetTotal: 0,
        TargetQ1: 0,
        TargetQ2: 0,
        TargetQ3: 0,
        TargetQ4: 0,
        TargetTotalUSD: 0,
        TargetQ1USD: 0,
        TargetQ2USD: 0,
        TargetQ3USD: 0,
        TargetQ4USD: 0,
        PercentInfo: [],
        Category: c.Category,
        SubCategory: c.SubCategory,
        TotalRebateValue: 0,
        TotalRebateValueUSD: 0,

        TotalNdp: 0,
        TotalNdpUSD: 0,
        TargetTotalNdp: 0,
        TargetQ1Ndp: 0,
        TargetQ2Ndp: 0,
        TargetQ3Ndp: 0,
        TargetQ4Ndp: 0,
        TargetTotalUSDNdp: 0,
        TargetQ1USDNdp: 0,
        TargetQ2USDNdp: 0,
        TargetQ3USDNdp: 0,
        TargetQ4USDNdp: 0,
        TotalRebateValueNdp: 0,
        TotalRebateValueUSDNdp: 0,
      }
      if (!notApplicable) {
        sales
          .filter((el) => el.Category === c.Category && el.SubCategory === c.SubCategory)
          .map((el) => {
            newItem.TotalNet += el.TotalSumLocalCurrency
            newItem.TotalNetUSD += el.TotalSumUSD

            newItem.TotalNdp += el.TotalSumLocalCurrencyNdp
            newItem.TotalNdpUSD += el.TotalSumUSDNdp
          })

        targets
          .filter((el) => el.Category === c.Category && el.SubCategory === c.SubCategory)
          .map((el) => {
            newItem.TargetTotal += el.TotalSumLocalCurrency
            newItem.TargetTotalNdp += el.TotalSumLocalCurrencyNdp

            newItem[`TargetQ${el.FQuarter}`] += el.TotalSumLocalCurrency
            newItem[`TargetQ${el.FQuarter}Ndp`] += el.TotalSumLocalCurrencyNdp

            newItem.TargetTotalUSD += el.TotalSumUSD
            newItem.TargetTotalUSDNdp += el.TotalSumUSDNdp

            newItem[`TargetQ${el.FQuarter}USD`] += el.TotalSumUSD
            newItem[`TargetQ${el.FQuarter}USDNdp`] += el.TotalSumUSDNdp
          })
      }
      valueItems.push(newItem)
    })
    if (valueItems.length) {
      const totalItem = CompenstaionHelper.calculateTotal(category, targets, sales, notApplicable)
      result.push(totalItem, ...valueItems)
    }
    if (result.length) {
      const totalSum: IRowItem = {
        TotalNet: 0,
        TotalNetUSD: 0,
        TargetTotal: 0,
        TargetQ1: 0,
        TargetQ2: 0,
        TargetQ3: 0,
        TargetQ4: 0,
        TargetTotalUSD: 0,
        TargetQ1USD: 0,
        TargetQ2USD: 0,
        TargetQ3USD: 0,
        TargetQ4USD: 0,
        PercentInfo: [],
        Category: 'jbp-total',
        SubCategory: 'jbp-overall',
        TotalRebateValue: 0,
        TotalRebateValueUSD: 0,

        TotalNdp: 0,
        TotalNdpUSD: 0,
        TargetTotalNdp: 0,
        TargetQ1Ndp: 0,
        TargetQ2Ndp: 0,
        TargetQ3Ndp: 0,
        TargetQ4Ndp: 0,
        TargetTotalUSDNdp: 0,
        TargetQ1USDNdp: 0,
        TargetQ2USDNdp: 0,
        TargetQ3USDNdp: 0,
        TargetQ4USDNdp: 0,
        TotalRebateValueNdp: 0,
        TotalRebateValueUSDNdp: 0,
      }
      result
        .filter((el) => el.SubCategory === 'jbp-overall')
        .map((el) => {
          totalSum.TargetTotal += el.TargetTotal
          totalSum.TargetQ1 += el.TargetQ1
          totalSum.TargetQ2 += el.TargetQ2
          totalSum.TargetQ3 += el.TargetQ3
          totalSum.TargetQ4 += el.TargetQ4
          totalSum.TargetTotalUSD += el.TargetTotalUSD
          totalSum.TargetQ1USD += el.TargetQ1USD
          totalSum.TargetQ2USD += el.TargetQ2USD
          totalSum.TargetQ3USD += el.TargetQ3USD
          totalSum.TargetQ4USD += el.TargetQ4USD
          totalSum.TotalNet += el.TotalNet
          totalSum.TotalNetUSD += el.TotalNetUSD

          totalSum.TargetTotalNdp += el.TargetTotalNdp
          totalSum.TargetQ1Ndp += el.TargetQ1Ndp
          totalSum.TargetQ2Ndp += el.TargetQ2Ndp
          totalSum.TargetQ3Ndp += el.TargetQ3Ndp
          totalSum.TargetQ4Ndp += el.TargetQ4Ndp
          totalSum.TargetTotalUSDNdp += el.TargetTotalUSDNdp
          totalSum.TargetQ1USDNdp += el.TargetQ1USDNdp
          totalSum.TargetQ2USDNdp += el.TargetQ2USDNdp
          totalSum.TargetQ3USDNdp += el.TargetQ3USDNdp
          totalSum.TargetQ4USDNdp += el.TargetQ4USDNdp
          totalSum.TotalNdp += el.TotalNdp
          totalSum.TotalNdpUSD += el.TotalNdpUSD
        })
      result.push(totalSum)
    }

    return result
  }

  public static toPercent = (val1: number, val2: number) => {
    return ((val1 / (val2 || 1)) * 100).toFixed(0)
  }

  public static CalculateMIFData = (
    partnerId: string,
    fyear: number,
    data: IFormActualsAndPlans[],
    basicInfo: IFormPartnerBasicInfo | IObjectAny
  ) => {
    const achievments = data.filter((el) => !el.IsTarget)
    const targets = data.filter((el) => el.IsTarget)
    const quarters: string[] = (basicInfo['MIFTargetsEditableQuarters'] || '')
      .trim()
      .split(',')
      .filter((el: string) => el !== '')
    const resItems: IMIFItem[] = []
    let hasData = false
    let achievment1 = 0
    let achievment2 = 0
    let achievment3 = 0
    let achievment4 = 0
    achievments.map((el) => {
      switch (el.FQuarter) {
        case 2:
          achievment2 += el.TotalUnitsNdp
          break
        case 3:
          achievment3 += el.TotalUnitsNdp
          break
        case 4:
          achievment4 += el.TotalUnitsNdp
          break
        default:
          achievment1 += el.TotalUnitsNdp
          break
      }
    })

    const achievmentsList = [
      achievment1,
      achievment2,
      achievment3,
      achievment4,
      achievment1 + achievment2 + achievment3 + achievment4,
    ]

    let targetSum = 0
    let targetSumNdp = 0
    for (let i = 1; i < 5; i++) {
      const target = targets.find((el) => el.FQuarter === i) || {
        UniqueId: '',
        EntryId: 0,
        PartnerId: partnerId,
        ProgramTypes: ProgramTypes.MPS,
        Category: 'jbp-mif-replacement',
        SubCategory: '',
        PL: '',
        FYear: fyear,
        FQuarter: i,
        IsTarget: 1,
        IsQuota: 0,
        LocalCurrency: '',
        TotalSumUSD: 0,
        TotalSumLocalCurrency: 0,
        TotalUnits: 0,
        TotalSumUSDNdp: 0,
        TotalSumLocalCurrencyNdp: 0,
        TotalUnitsNdp: 0,
        ShipmentSumUSD: 0,
        ShipmentSumLocalCurrency: 0,
        ShipmentUnits: 0,
        ShipmentSumUSDNdp: 0,
        ShipmentSumLocalCurrencyNdp: 0,
        ShipmentUnitsNdp: 0,
      }
      targetSum += target.TotalUnits
      targetSumNdp += target.TotalUnitsNdp
      resItems.push({
        ...target,
        Achievment: achievmentsList[i - 1],
        Changed: false,
        Editable: !!quarters.find((el) => Number(el) === i),
      })
    }

    resItems.splice(0, 0, {
      UniqueId: '',
      EntryId: 0,
      PartnerId: partnerId,
      ProgramTypes: ProgramTypes.MPS,
      Category: 'jbp-mif-replacement',
      SubCategory: '',
      PL: '',
      FYear: fyear,
      FQuarter: 4,
      IsTarget: 1,
      IsQuota: 0,
      LocalCurrency: '',
      TotalSumUSD: 0,
      TotalSumLocalCurrency: 0,
      TotalUnits: targetSum,
      TotalSumUSDNdp: 0,
      TotalSumLocalCurrencyNdp: 0,
      TotalUnitsNdp: targetSumNdp,
      Achievment: achievmentsList[4],
      Changed: false,
      Editable: false,
      ShipmentSumUSD: 0,
      ShipmentSumLocalCurrency: 0,
      ShipmentUnits: targetSum,
      ShipmentSumUSDNdp: 0,
      ShipmentSumLocalCurrencyNdp: 0,
      ShipmentUnitsNdp: targetSumNdp,
    })
    hasData = resItems.length > 0
    return {
      items: resItems,
      hasData: hasData,
    }
  }

  public static checkProportion = (data: ITargetProportions[]) => {
    let result = false
    data.map((el) => {
      if (el.item1 !== 0 && el.item2 !== 0) {
        result = result || el.item1 / el.item2 <= 1 / 50 || el.item2 / el.item1 <= 1 / 50
      }
    })
    return !result
  }
}
